import { DEFAULT_STORE_ID } from '../../types/signage';

// "*" is awkward in a URL, and "~" can never be part of a real Store ID.
const DEFAULT_SEGMENT = '~default';

export const storePath = (storeId: string): string =>
  `/signage/${storeId === DEFAULT_STORE_ID ? DEFAULT_SEGMENT : encodeURIComponent(storeId)}`;

export const storeIdFromSegment = (segment?: string): string =>
  !segment || segment === DEFAULT_SEGMENT ? DEFAULT_STORE_ID : decodeURIComponent(segment);

export const isDefaultStore = (storeId: string): boolean => storeId === DEFAULT_STORE_ID;

export const storeDisplayName = (storeId: string, name: string): string => (isDefaultStore(storeId) ? 'Default (all stores)' : name);
